import KeenSlider from "keen-slider";

class Faculty {
	constructor(dom) {
		this.NAME = "Faculty";
		this.dom = dom;
		this.row = dom.querySelector("[data-faculty-row]");
		this.prev = dom.querySelector("[data-faculty-prev]");
		this.next = dom.querySelector("[data-faculty-next]");
		this.slider = null;
	}

	init() {
		if (!this.row) return;

		// perView: "auto" reads each slide's own CSS width instead of dividing
		// the container evenly, so the existing responsive &__card flex-basis
		// breakpoints (85% / 45% / 410px) keep driving how many cards show at
		// each width — Keenslider only owns the sliding/dragging, not sizing.
		this.slider = new KeenSlider(this.row, {
			slides: { perView: "auto", spacing: 21 },
		});

		if (this.prev)
			this.prev.addEventListener("click", () => this.slider.prev());
		if (this.next)
			this.next.addEventListener("click", () => this.slider.next());
	}
}

export default Faculty;
